import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsPause2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M4.499 4.499H7.25V11.5H4.499zm4.251 0h2.751V11.5H8.75z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsPause2
